export default __webpack_public_path__ + "static/media/nature.7ca6499e.svg";